import { filterLocalizedLifeAreas } from '@griply/utils';
import { useSortedLocalizedLifeAreas } from 'features/life-areas';
import { useMemo } from 'react';
import { Goal } from 'shared/types/goal';

export const useFilteredLocalizedLifeAreas = (goals: Goal[]) => {
  const lifeAreas = useSortedLocalizedLifeAreas();

  return useMemo(
    () =>
      filterLocalizedLifeAreas(lifeAreas, { goals, showEmptyLifeAreas: false }),
    [goals, lifeAreas],
  );
};
